<form [formGroup]="ownerForm">
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col
        size="6"
        size-xs="12"
        size-md="6"
        size-lg="6"
        class="ion-margin-bottom ion-no-padding"
      >
        <ion-row>
          <ion-col
            size="3"
            size-xs="12"
            size-md="3"
            size-lg="3"
            class="ion-align-self-center ion-no-padding ion-hide-lg-down"
          >
            <ion-label class="text-dark align-label">{{
              'user_firstname' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="9" size-xs="12" size-md="9" size-lg="9">
            <ion-input class="disabled" formControlName="firstName"></ion-input>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col
            size="3"
            size-xs="3"
            size-md="3"
            size-lg="3"
            class="ion-align-self-center ion-no-padding ion-hide-lg-down"
          >
            <ion-label class="text-dark align-label">{{
              'user_lastname' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="9" size-xs="12" size-md="12" size-lg="9">
            <ion-input class="disabled" formControlName="lastName"></ion-input>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col
            size="3"
            size-xs="3"
            size-md="3"
            size-lg="3"
            class="ion-align-self-center ion-no-padding ion-hide-lg-down"
          >
            <ion-label class="text-dark align-label">{{
              'user_email' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="9" size-xs="12" size-md="9" size-lg="9">
            <ion-input class="disabled" formControlName="email"></ion-input>
          </ion-col>
        </ion-row>
      </ion-col>

      <ion-col
        size="6"
        size-xs="12"
        size-md="6"
        size-lg="6"
        class="ion-margin-bottom ion-padding-start"
      >
        <ion-row>
          <ion-col
            size="3"
            size-xs="3"
            size-md="3"
            size-lg="3"
            class="ion-align-self-center ion-no-padding ion-hide-lg-down"
          >
            <ion-label class="text-dark align-label">{{
              'user_telephone' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="9" size-xs="12" size-md="9" size-lg="9">
            <ion-input class="disabled" formControlName="telephone"></ion-input>
          </ion-col>
        </ion-row>
        <ion-row class="pb-05">
          <ion-col
            size="3"
            size-xs="3"
            size-md="3"
            size-lg="3"
            class="ion-align-self-center ion-no-padding ion-hide-lg-down"
          >
            <ion-label class="text-dark align-label">{{
              'user_language' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="9" size-xs="12" size-md="9" size-lg="9">
            <ion-select
              value="brown"
              ok-text="Okay"
              cancel-text="Dismiss"
              formControlName="language"
              class="disabled"
            >
              @for (language of languages(); track language.id) {
                <ion-select-option [value]="language.id">{{
                  language.name
                }}</ion-select-option>
              }
            </ion-select>
          </ion-col>
        </ion-row>

        @if (canEnable()) {
          <ion-row class="ion-margin-top">
            <ion-col
              size="3"
              size-xs="3"
              size-md="3"
              size-lg="3"
              class="ion-align-self-center ion-no-padding ion-hide-lg-down"
            >
            </ion-col>
            <ion-col
              size="9"
              size-xs="9"
              size-md="9"
              size-lg="9"
              class="ion-align-self-end"
            >
              <ion-button
                type="button"
                color="primary"
                (click)="onUpdateOwner()"
                [disabled]="!ownerForm.valid"
                ><small>{{ 'owner_update' | translate }}</small>
              </ion-button>
            </ion-col>
          </ion-row>
        }
      </ion-col>
    </ion-row>
  </ion-grid>
</form>
